/**
 * Acciones posibles sobre una tarjeta de curso cuando el alumno todavía no está
 * inscrito. El contenedor las resuelve a partir de los datos de entitlement que
 * envía el API (typeLabel / is_included / membresia_id) y la tarjeta solo las
 * renderiza.
 */
export const ACCESS_ACTION = {
    // El curso es accesible: gratis o cubierto por la membresía vigente.
    ENROLL: 'enroll',
    // El curso está cubierto por la membresía del alumno, pero ya venció.
    RENEW: 'renew',
    // El curso requiere una membresía distinta a la que tiene el alumno.
    UPGRADE: 'upgrade',
    // El curso se vende por separado: se envía al detalle para comprarlo.
    DETAIL: 'detail',
};
